module.exports = "/_next/static/images/08eda3e67464cc25e01a63d15c20066e-2-woman-working@2x.jpg.webp";